import { useCallback } from 'react'
import { DEFAULT_LOCALE, translate } from '@movmania/i18n'

export type TFunction = (
  path: string,
  vars?: Record<string, string | number>,
) => string

/**
 * L'app est en français. Le hook reste en place pour que le jour où l'anglais
 * revient, aucun composant n'ait à changer : seule la source de la locale
 * bougera ici.
 */
export function useT(): TFunction {
  return useCallback((path, vars) => translate(DEFAULT_LOCALE, path, vars), [])
}
